import { Column, TextInput } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { getText } from '../../../../../internal/TextLabels/index'
import IdentificationTypeSelector from '../IdentificationTypeSelector'

class PhysicalIdentification extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reference: props.reference,
      type: props.type,
    }
  }

  setValue(key, value) {
    this.setState({ [key]: value }, this.validateState)
  }

  validateState() {
    this.props.onChange({
      ...this.state,
      valid: !!(this.state.type && this.state.reference),
    })
  }

  render() {
    return (
      <div style={{ display: 'flex' }}>
        <Column col6 noPadding>
          <IdentificationTypeSelector
            id={`${this.props.name}_id_type`}
            onChange={value => this.setValue('type', value)}
            label={
              this.props.coApplicant
                ? getText('payApply.sign.idTypeCoapp')
                : getText('payApply.sign.idType')
            }
            value={this.state.type}
            disabled={this.props.disabled}
          />
          <TextInput
            id={`${this.props.name}_id_ref`}
            label={getText('payApply.sign.refnr')}
            value={this.state.reference || ''}
            placeholder={getText('payApply.sign.refNrPlaceholder')}
            onChange={e => this.setValue('reference', e.target.value)}
            skipValidation
            autoFocus={!this.props.coApplicant}
            disabled={this.props.disabled}
          />
        </Column>
        {this.props.children}
      </div>
    )
  }
}

PhysicalIdentification.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  coApplicant: PropTypes.bool,
  children: PropTypes.node,
  reference: PropTypes.any,
  type: PropTypes.any,
  disabled: PropTypes.bool,
}

PhysicalIdentification.defaultProps = {
  coApplicant: false,
  children: null,
  reference: null,
  type: null,
  disabled: false,
}

export default PhysicalIdentification
